module.exports = __webpack_public_path__ + "static/media/信息变更申请表（设备）.f410a25d.docx";